export const pushers = [
  {
    id: 'p-01',
    code: '推手 A · 代号「桥梁」',
    role: '资源对接',
    methods: '以项目合作为名义横向串联制作方与渠道，在关键节点完成资源置换。',
    links: ['影视项目 6 个', '经纪公司 3 家'],
  },
  {
    id: 'p-02',
    code: '推手 B · 代号「橡皮」',
    role: '舆情处置',
    methods: '擅长将单点争议拆分为多个无关话题，用节奏稀释公众注意力。',
    links: ['热点事件 14 起', '代理机构 2 家'],
  },
  {
    id: 'p-03',
    code: '推手 C · 代号「尺子」',
    role: '数据包装',
    methods: '负责把不可核验的曝光与互动整理成可对外的整齐报表。',
    links: ['刷量渠道 5 条', '品牌方 4 家'],
  },
  {
    id: 'p-04',
    code: '推手 D · 代号「邮差」',
    role: '素材分发',
    methods: '面向中小账号批量投放统一口径素材，形成看似自然的同步曝光。',
    links: ['营销账号 120+', '素材库 1 套'],
  },
  {
    id: 'p-05',
    code: '推手 E · 代号「收口」',
    role: '结算衔接',
    methods: '通过多层外包主体完成费用结算，使资金路径难以被直接追溯。',
    links: ['外包主体 7 个', '结算周期 90 天'],
  },
];